import { render, staticRenderFns } from "./general.vue?vue&type=template&id=ddbd3c12&"
import script from "./general.vue?vue&type=script&lang=js&"
export * from "./general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddbd3c12')) {
      api.createRecord('ddbd3c12', component.options)
    } else {
      api.reload('ddbd3c12', component.options)
    }
    module.hot.accept("./general.vue?vue&type=template&id=ddbd3c12&", function () {
      api.rerender('ddbd3c12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms_portal/orders/tabs/general.vue"
export default component.exports